<template>
  <ModalBackdrop name="unavailableReportForm">
    <template v-slot:body="{ params }">
      <div class="flex--column align--center text--center mt--2">
        <p class="paragraph bold mb--2">
          Этот отчет недоступен в пакете <span class="text--blue">Free</span>.
          Попробуйте пакет
          <span class="text--blue cursor-pointer" @click="gotoTariffs"
            >перейдя по ссылке</span
          >.
        </p>
        <BaseButton
          color="blue"
          size="large"
          class="form__button mt--5"
          @click="openRequestModal"
          >Хочу больше аналитики</BaseButton
        >
        <p class="paragraph bold mt--2">
          <span class="text--blue text--link" @click="gotoReport(params.id)"
            >Открыть как Demo</span
          >
        </p>
      </div>
    </template>
  </ModalBackdrop>
</template>

<script>
import ModalBackdrop from "@/components/common/ModalBackdrop.vue";
export default {
  components: {
    ModalBackdrop,
  },
  props: {
    reportType: {
      type: Number,
      required: true,
    },
  },
  // data() {
  //   return {
  //     clientType: null,
  //   };
  // },
  // watch: {
  //   reportType: {
  //     handler(typeId) {
  //       this.clientType = typeId == 1 ? "Retail" : "Bussiness";
  //     },
  //     immediate: true,
  //   },
  // },
  methods: {
    openRequestModal() {
      this.$modal.hide("unavailableReportForm");
      this.$modal.show("requestReportForm");
    },
    gotoTariffs() {
      this.$router.push({ name: "Tariffs" });
    },
    gotoReport(id) {
      this.$router.push({
        name: "chartReport",
        params: {
          id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
